// types
import { i18nDispatcherCodebooks } from 'models/i18n';

// ==============================|| I18N EN CODEBOOKS ||============================== //

const enDispatcherCodebooks: i18nDispatcherCodebooks = {
  LOSS_OF_POWER_SUPPLY_VOLTAGE: { title: 'Loss of power supply voltage' },
  BATTERY_COMMUNICATION_MALFUNCTION: { title: 'Battery communication failure' },
  BATTERY_CHARGING_FAILURE: { title: 'Battery charging failure' },
  BATTERY_MALFUNCTION: { title: 'Battery malfunction' },
  LOSS_OF_SIGNAL_AND_CONTROL_VOLTAGE: {
    title: 'Loss of signal and control volatge'
  },
  OOM_METER_COMMUNICATION_FAILURE: {
    title: 'Delivery point communication failure'
  },
  DEVICE_METER_COMMUNICATION_FAILURE: {
    title: 'Device meter communication failure'
  },
  LOCAL_DELIVERY_POINT_CONTROL: { title: 'Local delivery point control' },
  HRM_BLOCKED_BY_DISTRIBUTOR: { title: 'HRM blocked by distributor' },
  PROTECTOR_FAILURE: { title: 'Protector failure' },
  PROTECTOR_ACTION: { title: 'Protector action' },
  FUSE_BLOWN: { title: 'Fuse blown' },
  DEVICE_FAILURE: { title: 'Device failure' },
  0: { title: 'Intermediate position' },
  1: { title: 'Off' },
  2: { title: 'On' },
  3: { title: 'Failure' },
  ONLINE: { title: 'Online' },
  OFFLINE: { title: 'Offline' },
  AIEMS_OPERATION: { title: 'AIEMS operation' },
  LOCAL_OPERATION: { title: 'Local operation' },
  UNKNOWN: { title: 'Unknown' },
  P_MODE: { title: 'Power mode' },
  Q_MODE: { title: 'Flow rate mode' },
  WATER_LEVEL_MODE: { title: 'Water level mode' }
};

export default enDispatcherCodebooks;
